import { toast } from "sonner";
import { AdminShell } from "@project/admin/components/admin-shell";
import { SectionCard } from "@project/admin/components/module-ui";
import { Input } from "@project/components/ui/input";
import { Textarea } from "@project/components/ui/textarea";
import { Label } from "@project/components/ui/label";
import { Button } from "@project/components/ui/button";
import { FamilyDetails } from "@project/admin/components/family-details";
import { Save } from "lucide-react";

function F({
  label,
  full = false,
  children,
}: {
  label: string;
  full?: boolean;
  children: React.ReactNode;
}) {
  return (
    <div className={full ? "md:col-span-2 lg:col-span-3" : ""}>
      <Label className="text-foreground/80 mb-1 block text-xs font-medium">
        {label}
      </Label>
      {children}
    </div>
  );
}

export default function AdmissionRecommendationForm() {
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    toast.success("Recommendation saved (prototype)");
  };

  return (
    <AdminShell
      title="Admission Recommendation Form"
      subtitle="Recorded when a community member recommends an elder"
      actions={
        <Button form="rec-form" size="sm">
          <Save className="mr-1 h-3.5 w-3.5" /> Save Recommendation
        </Button>
      }
    >
      <form id="rec-form" onSubmit={onSubmit} className="space-y-4">
        <SectionCard title="Recommender Details">
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            <F label="Date">
              <Input
                type="date"
                defaultValue={new Date().toISOString().slice(0, 10)}
              />
            </F>
            <F label="Name">
              <Input />
            </F>
            <F label="Surname">
              <Input />
            </F>
            <F label="Village">
              <Input />
            </F>
            <F label="Taluka">
              <Input />
            </F>
            <F label="District">
              <Input />
            </F>
            <F label="Address" full>
              <Textarea rows={2} />
            </F>
            <F label="Occupation">
              <Input />
            </F>
            <F label="Mobile Number">
              <Input type="tel" />
            </F>
            <F label="Email ID">
              <Input type="email" />
            </F>
            <F label="Date of Birth">
              <Input type="date" />
            </F>
          </div>
        </SectionCard>

        <SectionCard title="Reason for Recommendation">
          <div className="grid gap-4 md:grid-cols-2">
            <F label="Reason for Recommendation" full>
              <Textarea rows={3} />
            </F>
            <F label="Referral Source">
              <Input />
            </F>
            <F label="Referrer Name">
              <Input />
            </F>
          </div>
        </SectionCard>

        <FamilyDetails
          title="Family Member Table"
          subtitle="Family members of the recommended elder"
          columns={["name", "relationship", "occupation", "income"]}
          initialRows={3}
        />

        <SectionCard title="Remarks">
          <F label="Additional Remarks" full>
            <Textarea rows={3} />
          </F>
        </SectionCard>
      </form>
    </AdminShell>
  );
}
